/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-restricted-globals */

import React, { useContext, useEffect, useState, useCallback } from "react";
import { Button2, Footer, Header, Surface, Tab, Text } from "components";
import { ButtonContainer, LoginContainer, TextStyled, Field, BaseWrapper } from "./styles";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  ComboBox,
  Loader,
  Button,
  InputField,
  Label,
  MultiSelectField,
  Section,
  SectionHeader,
  SectionLegend,
  SectionTitle,
  SelectField,
} from "@fitinsur/components";
import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { Form, Formik } from "formik";
import { Col, Row } from "components/Grid";
import * as Yup from "yup";
import FitinsurAPI from "utils/src/fitinsur-api";
import { MessageCenter } from "utils";
import Crypt from "utils/src/crypt";
import Access from 'constants/Access';
import {
  LoaderContext
} from '@fitinsur/contexts';
import TopHeader from "components/TopHeader/index";

import { msalInstance } from "./authMsal";
import { loginRequest } from "./authConfig";

export default function LoginPage(match) {
  const location = useLocation();
  const { updateIsLoadingStatus } = useContext(LoaderContext);

  console.log('LoginPage - BEGIN');

  const crypt = new Crypt();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const [loginState, setLoginState] = useState(authContext.status);
  const [subtitleMessage, setSubtitleMessage] = useState(
    'Por favor insira seu email e senha para continuar'
  );
  
  const [showPassword, setShowPassword] = useState(false);
  const redirectTo = new URLSearchParams(location.search).get('redirect') || '/list';

  const history = useHistory();

  const goToHomePage = useCallback(() => {
    history.push(redirectTo);
  }, [history]);

  const goToChangePassPage = useCallback(() => {
    authContext.changedPassword = false;
    history.push('change-password');
  }, [authContext.changedPassword, history]);

  useEffect(() => {
    localStorage.clear();
    //if (!match.params?.redirect && authContext?.msalAccount) authContext.msalAccount=null;
    authContext.msalAccount=null;
    updateIsLoadingStatus(false);
  }, []);

  const handleSubmit = useCallback(
    (values) => {
      updateIsLoadingStatus(true);
      console.log('onSubmit - BEGIN');

      const mc = new MessageCenter();
      const fitinsur = new FitinsurAPI();

      fitinsur
        .requestLogin(values.username, values.password, Access.APLICATION, values.msalAccount)
        .then((response) => response.json())
        .then((data) => {
          if (data.ret_code === 200) {

            const { token, username } = data.ret_value;
            console.log('requestLogin - Success:', data);

            authContext.login_response = data;

            // --------------------------------------------------
            // production minor fix - change password
            if (data?.ret_value?.loginCount == 0 || data?.ret_value?.userChangePassword > 0) {
              updateIsLoadingStatus(false);
              goToChangePassPage();
              return;
            }
            // --------------------------------------------------

            fitinsur
              .requestAccess(username, "READ", Access.APLICATION, null, null, token)
              .then((response) => response.json())
              .then((response) => {
                if (response.ret_code === 200) {
                  authContext.status = true;
                  authContext.username = values.username;
                  authContext.person_product = data.ret_person_product;
                  authContext.region = data.ret_value.region;
                  authContext.enumProfile = data.ret_value.enumProfile;
                  authContext.firstLogin = false;

                  if (data.ret_token) {
                    authContext.token = data.ret_token;
                    // LEGACY LOGIN
                  }

                  if (data.ret_value.token) {
                    authContext.token = data.ret_value.token;
                    // LOGIN V2
                  }

                  if (data.ret_value) {
                    authContext.firstLogin =
                      Number(data.ret_value.loginCount) <= 0;
                  }

                  localStorage.setItem('fitinsur-session', JSON.stringify({"fitinsur-sompo": crypt.encryptJson(authContext)}));

                  console.log(authContext);
                  console.log(authContext.firstLogin);
                  console.log('requestLogin: authContext');

                  authContext.firstLogin ||
                    data.ret_value.userChangePassword > 0
                    ? goToChangePassPage()
                    : goToHomePage();
                } else {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.token = '';
                  authContext.person_product = [];
                  authContext.user_region = '';

                  setLoginState(false);

                  mc.error('Error logging in');
                  setSubtitleMessage('Error logging in');
                }
              });
          } else {
            authContext.status = false;
            authContext.username = values.username;
            authContext.token = '';
            authContext.person_product = [];
            authContext.user_region = '';

            setLoginState(false);

            const errorMsg = data.ret_code < 500 ?
              data.ret_msg_details :
              'Erro ao efetuar login';
            
            mc.error(errorMsg);
            setSubtitleMessage(errorMsg);
          }

          updateIsLoadingStatus(false);
        })
        .catch((error) => {
          authContext.status = false;
          authContext.username = values.username;
          authContext.token = '';
          authContext.person_product = [];
          authContext.user_region = '';
          authContext.login_response = 'ERROR: ' + error.message;

          updateIsLoadingStatus(false);
          setLoginState(false);

          mc.error('Erro ao efetuar login');
          setSubtitleMessage('Erro ao efetuar login');

          console.log(error);
          console.error('requestLogin - Error:', error);
        });

      console.log('onSubmit - END');
    },
    [authContext, crypt, goToChangePassPage, goToHomePage, loading]
  );  

  useEffect(() => {
    console.log("LoginPage - authContext.msalAccount:", authContext?.msalAccount);
    if (authContext?.msalAccount) {
      const values = {
        username: authContext?.msalAccount?.username,
        password: "*****************",
        msalAccount: authContext?.msalAccount
      }
      handleSubmit(values);
    }
  }, [authContext?.msalAccount]);  

  const handleLoginMicrosoft = async (loginType) => {
    try {
      if (loginType === "popup") {
        /**
         * When using popup and silent APIs, we recommend setting the redirectUri to a blank page or a page 
         * that does not implement MSAL. Keep in mind that all redirect routes must be registered with the application
         * For more information, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations 
         */
          updateIsLoadingStatus(true);
          const loginResponse = await msalInstance.loginPopup({
                ...loginRequest,
                redirectUri: process.env.REACT_APP_POPUP_REDIRECT_URI, // e.g. /redirect
            });
          authContext.msalAccount = loginResponse?.account;
          console.log("AuthRedirect - authContext.msalAccount:",authContext?.msalAccount);
          updateIsLoadingStatus(false);
          history.push('login');      
        } else if (loginType === "redirect") {
            msalInstance.loginRedirect(loginRequest);
        } 
    } catch (error) {
      console.error("AuthRedirect - handleLogin - error:",error);
      updateIsLoadingStatus(false);
      //history.push('login');
    }   
  }  

    return (
    <BaseWrapper>
      <TopHeader />
      <LoginContainer>
        <Row>
          <Col xs={12} md={12}>
            <Header title='Acesso' subtitle={subtitleMessage} />
          </Col>
        </Row>
        <Formik
          onSubmit={handleSubmit}
          initialValues={{ username: authContext.username || authContext?.msalAccount?.username || '', password: '' }}
          validationSchema={Yup.object({
            username: Yup.string().required('* Campo obrigatório'),
            password: Yup.string().required('* Campo obrigatório'),
          })}
        >
          {(props) => (
            <Form>
              <Section>
                <Row>
                  <Col xs={12}>
                    <Field
                      name="username"
                      label="E-mail:"
                      type="text"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      disabled={loginState == true}
                      originalSize
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <Field
                      name="password"
                      label="Senha:"
                      type={showPassword ? "text" : "password"}
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      disabled={loginState == true}
                      originalSize
                      rightIcon={showPassword ? "openEye" : "closedEye"}
                      rightIconClick={() => setShowPassword(state => !state)}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'end', 
                        marginTop: props?.errors.hasOwnProperty('password') ? 40 : 15 }}>
                      <Link
                        to="forgot-password"
                        style={{ textDecoration: "none" }}
                      >
                        <TextStyled>Esqueceu sua senha?</TextStyled>
                      </Link>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <ButtonContainer>
                      {loginState == true &&
                        ((authContext.status = false), setLoginState(false))}
                      {/* linha de cima é do botão logout na pagina login */}

                      {loginState !== true && (
                        <>
                          <Button
                            primary
                            type="submit"
                            id="btnLogin"
                            style={{}}
                            disabled={loginState == true}
                          >
                            Entrar
                          </Button>                        
                          <Button
                            primary
                            type="button"
                            id="btnLoginMicrosoft"
                            style={{}}
                            disabled={loginState == true}
                            onClick={() => handleLoginMicrosoft("popup")}
                          >
                            Entrar com Microsoft
                          </Button>                        
                        </>
                      )}
                    </ButtonContainer>
                  </Col>
                </Row>
              </Section>
            </Form>
          )}
        </Formik>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </LoginContainer>
      <Footer />
    </BaseWrapper>
  );
}
